import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

// Initial state
const initialState = {
  bookingSnapshot: null,
  filters: {
    modalFiltersRules: undefined,
    modalConditions: undefined,
  },
};
// Actual Slice
export const bookingsSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: {
    addSnapshot: (state, { payload }) => {
      if (JSON.stringify(state.bookingSnapShot) === JSON.stringify(payload)) {
        return;
      }
      const user = JSON.parse(localStorage.user);
      const snapshot = {};
      snapshot[user.email] = payload;
      localStorage.bookingSnapshot = JSON.stringify(snapshot);
      state.bookingSnapshot = payload;
    },
    clearSnapshot: (state) => {
      const user =
        localStorage.user && localStorage.user !== 'undefined'
          ? JSON.parse(localStorage.user)
          : {};
      const snapshot =
        localStorage.bookingSnapshot &&
        localStorage.bookingSnapshot !== 'undefined'
          ? JSON.parse(localStorage.bookingSnapshot)
          : {};
      snapshot[user.email] = null;
      localStorage.bookingSnapshot = JSON.stringify(snapshot);
      state.bookingSnapshot = null;
    },
    filtersModalConditionBookingsChangeSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },
    filtersModalRulesBookingsChangeSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },
    resetModalBookingsChangeSuccess: (state) => {
      state.filters.modalConditions = null;
      state.filters.modalFiltersRules = null;
    },
    // Special reducer for hydrating the state. Special case for next-redux-wrapper
    extraReducers: {
      [HYDRATE]: (state, action) => {
        return {
          ...state,
          ...action.payload.errors,
        };
      },
    },
  },
});

export const {
  addSnapshot,
  clearSnapshot,
  filtersModalConditionBookingsChangeSuccess,
  filtersModalRulesBookingsChangeSuccess,
  resetModalBookingsChangeSuccess,
} = bookingsSlice.actions;

export const selectBookingsState = (state) => state.bookings;

export default bookingsSlice.reducer;

export const filtersModalConditionBookingsChange = (conditions) => {
  return (dispatch) => {
    dispatch(filtersModalConditionBookingsChangeSuccess(conditions));
  };
};
export const filtersModalRulesBookingsChange = (rules) => {
  // console.log(rules);
  return (dispatch) => {
    dispatch(filtersModalRulesBookingsChangeSuccess(rules));
  };
};
export const resetModalBookingsChange = () => {
  return (dispatch) => {
    dispatch(resetModalBookingsChangeSuccess());
  };
};
